import {
  ChartContainer,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  getChartLegendItems,
} from '@/components/shadcn/charts'
import { ChartRadarConfig, ChartRadarDataItem } from './types'
import { PolarAngleAxis, PolarGrid, Radar, RadarChart } from 'recharts'
import { useState } from 'react'

export function RadarChartBody({ chartConfig, data }: { chartConfig: ChartRadarConfig; data: ChartRadarDataItem[] }) {
  const { config, dataKeys } = chartConfig
  const [selectedDataKey, setSelectedDataKey] = useState<string | undefined>(undefined)
  const handleDataKeyClick = (dataKey: string) => {
    setSelectedDataKey((prev) => (prev === dataKey ? undefined : dataKey))
  }
  return (
    <ChartContainer
      className="mx-auto h-full w-full"
      config={config}
      legend={
        <ChartLegendContent
          items={getChartLegendItems(config, dataKeys)}
          clickHandler={dataKeys.length > 1 ? handleDataKeyClick : undefined}
        />
      }
    >
      <RadarChart data={data}>
        <ChartTooltip content={<ChartTooltipContent />} />
        <PolarAngleAxis dataKey={chartConfig.categoryKey} />
        {chartConfig.gridType !== 'none' && <PolarGrid gridType={chartConfig.gridType} />}
        {dataKeys.map((dataKey) => (
          <Radar
            className={!selectedDataKey || selectedDataKey === dataKey ? '' : 'hidden'}
            key={dataKey}
            dataKey={dataKey}
            name={dataKey}
            // fill={config[dataKey]?.color ? hexToHslaOrPassthrough(config[dataKey].color, 0.2) : undefined}
            fill={config[dataKey]?.color}
            // fillOpacity={chartConfig.fillOpacity ? chartConfig.fillOpacity / 100 : undefined}
            fillOpacity={chartConfig.fillOpacity / 100}
            stroke={chartConfig.showOutline ? config[dataKey]?.color : undefined}
            strokeWidth={chartConfig.showOutline ? 2 : 0}
            onClick={
              dataKeys.length > 1
                ? () => {
                    handleDataKeyClick(dataKey)
                  }
                : undefined
            }
            role={dataKeys.length > 1 ? 'button' : undefined}
          />
        ))}
      </RadarChart>
    </ChartContainer>
  )
}
